import React from "react";
import styled from "@emotion/styled";
import MenuSelection from "./MenuItemSelectionGrid.js";
import MenuUnlimitedScroll from './MenuItemUnlimitedScroll';
// import MenuSelectionBar from "./MenuItemSelectionBar.js";
import MenuInfoContainer from "./MenuInfoContainer.js";
import RecentBoughtItems from "./RecentBoughtItems.js";
import MenuRecommendationItems from "./MenuRecommendationItems.js";
import { ThemeContext, UserContext, LanguageContext } from "../contexts/Context";
import "../styles/styles.css";
import { navigate } from "@reach/router";

const MenuContainer = ({
  height,
  width,
  headerHeight,
  sidebarWidth,
  menuSelectionFormRef,
  selectedCategory,
  selectedMenu,
  setSelectedMenu,
  setSelectedCategory,
  theme,
  cart,
  addItemDirect,
  removeFromCart,
  unlimitedScroll,
  menuList,
  lanIndex,
  isLanReverse,
  isScrolling,
  lastPos,
  setLastPos,
  catPos,
  addRecItemToCart,
  onAddToCart,
  addToCartText,
  addRecentItem,
  recentBought,
  recentItem,
  menuRecommendation,
  setScrollDown,
  topCatType,
  isScrollDown,
  mobileTakeawayOffset
}) => {
  const themeContext = React.useContext(ThemeContext);
  const userContext = React.useContext(UserContext);
  const languageContext = React.useContext(LanguageContext);

  let selectedItems = {};
  for (let ct of cart) {
    if (selectedItems[ct.codeId]) {
      selectedItems[ct.codeId] += ct.qty;
    } else {
      selectedItems[ct.codeId] = ct.qty;
    }
  }
  const closeMenu = () => {
    setSelectedMenu(null);
    if (selectedCategory != null) {
      let cat = selectedCategory.category;
      if (cat != null) {
        cat = cat.replaceAll("/", "").replaceAll("%", "");
        if (!unlimitedScroll)
          navigate('/menu/menu/' + cat);
        else
          navigate('/menu');
      }
    }
  }

  React.useEffect(() => {
    const menuScroll = document.getElementById("menu_scroll");
    if (!menuScroll) return undefined;
    menuScroll.style.overflowY = selectedMenu ? "hidden" : "auto";

    return () => {
      menuScroll.style.overflowY = "auto";
    };
  }, [selectedMenu]);


  return (
    <RootContainer id="menu_scroll" themeContext={themeContext} headerHeight={headerHeight} sidebarWidth={sidebarWidth} width={width} height={height} topCatType={topCatType} catPos={catPos} isMenuSelected={false} isScrollDown={isScrollDown} mobileTakeawayOffset={mobileTakeawayOffset}>
      {(!selectedMenu && menuRecommendation && menuRecommendation.options.length > 0) &&
        <MenuRecommendationItems
          recommendation={menuRecommendation}
          width={width}
          sidebarWidth={sidebarWidth}
          theme={theme}
          selectedItems={selectedItems}
          addItemDirect={addItemDirect}
          cart={cart}
          removeFromCart={removeFromCart}
          setSelectedMenu={setSelectedMenu}
          menuSelectionFormRef={menuSelectionFormRef}
          catPos={catPos}
          setLastPos={setLastPos}
        />
      }
      {(!selectedMenu && recentBought && recentItem && recentItem.length > 0 && unlimitedScroll) &&
        <React.Fragment>
          <RecentBoughtItems
            width={width}
            menuSelectionFormRef={menuSelectionFormRef}
            selectedItems={selectedItems}
            theme={theme}
            sidebarWidth={sidebarWidth}
            headerHeight={headerHeight}
            lanIndex={lanIndex}
            isLanReverse={isLanReverse}
            addRecentItem={addRecentItem}
            setSelectedMenu={setSelectedMenu}
          />
        </React.Fragment>
      }

      {(selectedCategory || unlimitedScroll) ? (
        <React.Fragment>
          {(selectedMenu && (!addItemDirect || (addItemDirect && selectedMenu.optionArray.length > 0))) &&
            <ItemModalOverlay onClick={closeMenu} role="presentation">
              <ItemModalDialog
                themeContext={themeContext}
                onClick={(event) => event.stopPropagation()}
                role="dialog"
                aria-modal="true"
                aria-label={selectedMenu.title || "Menu item details"}
              >
                <MenuInfoContainer
                  width={Math.min(width, 720)}
                  menuSelectionFormRef={menuSelectionFormRef}
                  selectedMenu={selectedMenu}
                  theme={theme}
                  isEdit
                  setShow={closeMenu}
                  cp={catPos}
                  addRecItemToCart={addRecItemToCart}
                  onAddToCart={onAddToCart}
                  addToCartText={addToCartText}
                />
              </ItemModalDialog>
            </ItemModalOverlay>
          }
          {unlimitedScroll ?
            <MenuUnlimitedScroll
              width={width}
              height={height}
              sidebarWidth={sidebarWidth}
              headerHeight={headerHeight}
              theme={theme}
              selectedItems={selectedItems}
              addItemDirect={addItemDirect}
              cart={cart}

              menuList={menuList}
              selectedCategory={selectedCategory}
              setSelectedMenu={setSelectedMenu}
              setSelectedCategory={setSelectedCategory}
              removeFromCart={removeFromCart}
              lanIndex={lanIndex}
              isLanReverse={isLanReverse}
              isScrolling={isScrolling}
              lastPos={lastPos}
              setLastPos={setLastPos}
              cp={catPos}
              menuSelectionFormRef={menuSelectionFormRef}
              setScrollDown={setScrollDown}
            />
            :
            <MenuSelection //display list of item
              width={width}
              height={height}
              theme={theme}
              sidebarWidth={sidebarWidth}
              headerHeight={headerHeight}
              selectedItems={selectedItems}
              addItemDirect={addItemDirect}
              cart={cart}
              selectedCategory={selectedCategory}
              setSelectedMenu={setSelectedMenu}
              setSelectedCategory={setSelectedCategory}
              removeFromCart={removeFromCart}
              menuSelectionFormRef={menuSelectionFormRef}
              cp={catPos}
              setScrollDown={setScrollDown}
              isScrolling={isScrolling}

            />
          }
        </React.Fragment>
      ) : (
        <PromptContainer
          themeContext={themeContext}
          userContext={userContext}
          height={height}
        >
          {userContext.bgImg === ""
            ? languageContext[userContext.lanIndex].bgTxt
            : ""}
        </PromptContainer>
      )}
    </RootContainer>
  );
};
export default React.memo(MenuContainer);

const RootContainer = styled.div`
  position: relative;
  box-sizing: border-box;
  text-align: center;
  margin-right: 1px;
  background-color: ${(props) => props.themeContext.backgroundColor};
  height: calc(100vh - ${(props) => props.headerHeight}px);
  width: ${(props) => props.width - props.sidebarWidth}px;
  margin-top: ${props => props.headerHeight}px;
  margin-left: ${(props) => props.sidebarWidth}px;
  scrollbar-width: none;
  scrollbar-color: transparent transparent;
  scroll-behavior: smooth;
  &::-webkit-scrollbar {
    display: none; 
  }
  overflow-y: auto;

  @media (max-width: 767px) {
    height: calc(100vh - ${(props) => props.headerHeight}px - 8px);
    margin-bottom: 8px;
  }
`;

const ItemModalOverlay = styled.div`
  position: fixed;
  inset: 0;
  z-index: 20;
  display: flex;
  padding: 8px;
  box-sizing: border-box;
  align-items: center;
  justify-content: center;
  background: rgba(0, 0, 0, 0.58);

  @media (max-width: 767px) {
    padding: 64px 0 0;
    align-items: flex-end;
  }
`;

const ItemModalDialog = styled.div`
  position: relative;
  width: 100%;
  max-width: 1200px;
  max-height: calc(100dvh - 16px);
  border-radius: 16px;
  background: ${(props) => props.themeContext.backgroundColor};
  box-shadow: 0 18px 52px rgba(0, 0, 0, 0.35);
  overflow-x: hidden;
  overflow-y: auto;

  @media (max-width: 767px) {
    --item-detail-height: calc(100dvh - 64px);
    height: var(--item-detail-height);
    max-height: var(--item-detail-height);
    border-radius: 18px 18px 0 0;
    overflow: hidden;
  }

  @media (min-width: 768px) {
    width: calc(100% - 48px);
    max-height: calc(100dvh - 80px);
  }
`;

const PromptContainer = styled.div`
  display: grid;
  color: darkgrey;
  height: calc(100vh - 35px);
  width: 100%;
  align-items: center;
  background-image: url(${(props) => "https://ireachfnb.com/" + props.userContext.bgImg});
  /*background-image: url(${(props) => "https://newdemo.chachingfnb.com/" + props.userContext.bgImg});*/
  background-position:  center;
  background-size: cover;
  
`;
